
import React, { useState } from "react";
import { Container, Tab } from "@mui/material";
import TabsMenu from "../../components/TabsMenu";
import { TabPanel } from "@mui/lab";
import HeaderHelpPage from "../../components/HeaderHelpPage";

// Components
import AllMerchantPayoutInfo from "./all";
import PendingMerchantPayoutInfo from "./pending";
import HistoryMerchantPayoutInfo from "./history";

const MerchantPayoutInfo = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const handleChange = (event, value) => {
    setSelectedView(value);
  };

  return (
    <Container>
      <HeaderHelpPage title="Merchant Payout Info" description="Allow Oxygen7 user to manage a merchant payout info." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        <TabPanel value="All">
          <AllMerchantPayoutInfo userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingMerchantPayoutInfo userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryMerchantPayoutInfo userRole={userRole} />
        </TabPanel>
      </TabsMenu>
    </Container>
  );
};

export default MerchantPayoutInfo;